// Mind2Magic CRM — Settings, Hitos & Plantillas Module
// Extracted from index.html Step 8.

import { defaultSettings, OPERADORES_HITOS, ICONOS_HITOS } from './constants.js'
import { store } from './store.js'

// ========== SETTINGS LOAD / SAVE / RESET ==========

function updateComisionLabels() {
    const pct = store.settings.comisionM2M || 70;
    const txt = `Comisión M2M (${pct}%)`;
    const lblF = document.getElementById('lblFCommM2M');
    const lblE = document.getElementById('lblECommM2M');
    if (lblF) lblF.textContent = txt;
    if (lblE) lblE.textContent = txt;
}

function loadSettings() {
    const saved = localStorage.getItem('m2m_settings');
    const state = store;
    if (saved) {
        try {
            state.settings = { ...defaultSettings, ...JSON.parse(saved) };
        } catch (e) {
            state.settings = { ...defaultSettings };
        }
    }
    state.modoCompleto = !state.settings.modoCompactoDefault;
    state.ocultarValores = state.settings.ocultarValoresDefault;
    state.showHistorico = state.settings.incluirHistoricoDefault;
    if (state.settings.numberFormat) state.numberFormat = state.settings.numberFormat;
    updateComisionLabels();
}

function openSettings() {
    const { settings, team } = store;
    document.getElementById('settingComisionM2M').value = settings.comisionM2M;
    document.getElementById('settingVentanaViaje').value = settings.ventanaViaje;
    document.getElementById('settingFormatoFecha').value = settings.formatoFecha;
    document.getElementById('settingAbonoDisney').value = settings.abonoDisney;
    document.getElementById('settingAbonoUniversal').value = settings.abonoUniversal;
    document.getElementById('settingAbonoCrucero').value = settings.abonoCrucero;
    document.getElementById('settingAbonoHotel').value = settings.abonoHotel;
    document.getElementById('settingAlertaAbono').value = settings.alertaAbono;
    document.getElementById('settingAlertaPagoFinal').value = settings.alertaPagoFinal;
    document.getElementById('settingAlertaViaje').value = settings.alertaViaje;
    document.getElementById('settingAlertaWhatsApp').value = settings.alertaWhatsApp ?? 2;
    document.getElementById('settingAutoTareaWhatsApp').checked = settings.autoTareaWhatsApp !== false;
    document.getElementById('settingModoCompacto').checked = settings.modoCompactoDefault;
    document.getElementById('settingOcultarValores').checked = settings.ocultarValoresDefault;
    document.getElementById('settingIncluirHistorico').checked = settings.incluirHistoricoDefault;
    document.getElementById('settingUIFontScale').value = settings.uiFontScale || 1.0;

    const select = document.getElementById('settingResponsableDefault');
    select.innerHTML = '<option value="">-- Primer miembro --</option>' +
        team.map(t => `<option value="${t.nombre}" ${settings.responsableDefault === t.nombre ? 'selected' : ''}>${t.nombre}</option>`).join('');

    document.getElementById('settingNumberFormat').value = store.numberFormat || 'en-US';

    renderHitosSettings();
    updateDatePreview();
    window.openModal('settingsModal');
}

function updateDatePreview() {
    const formato = document.getElementById('settingFormatoFecha').value;
    const preview = document.getElementById('settingsDatePreview');
    const sampleDate = '2026-06-06';
    preview.textContent = window.formatDateWithFormat(sampleDate, formato);
}

function saveSettings() {
    const state = store;
    const settings = state.settings;
    const _v = (id, fallback) => document.getElementById(id)?.value ?? fallback;
    const _c = (id) => document.getElementById(id)?.checked ?? false;
    settings.comisionM2M = parseInt(_v('settingComisionM2M', 70)) || 70;
    settings.ventanaViaje = parseInt(_v('settingVentanaViaje', 10)) || 10;
    settings.responsableDefault = _v('settingResponsableDefault', '');
    settings.formatoFecha = _v('settingFormatoFecha', 'dd/mm/yyyy');
    settings.abonoDisney = parseInt(_v('settingAbonoDisney', 200)) || 200;
    settings.abonoUniversal = parseInt(_v('settingAbonoUniversal', 200)) || 200;
    settings.abonoCrucero = parseInt(_v('settingAbonoCrucero', 25)) || 25;
    settings.abonoHotel = parseInt(_v('settingAbonoHotel', 100)) || 100;
    settings.alertaAbono = parseInt(_v('settingAlertaAbono', 7)) || 7;
    settings.alertaPagoFinal = parseInt(_v('settingAlertaPagoFinal', 30)) || 30;
    settings.alertaViaje = parseInt(_v('settingAlertaViaje', 14)) || 14;
    settings.alertaWhatsApp = parseInt(_v('settingAlertaWhatsApp', 2)) || 2;
    settings.autoTareaWhatsApp = _c('settingAutoTareaWhatsApp');
    settings.modoCompactoDefault = _c('settingModoCompacto');
    settings.ocultarValoresDefault = _c('settingOcultarValores');
    settings.incluirHistoricoDefault = _c('settingIncluirHistorico');

    settings.hitos = collectHitosFromForm();

    // Number format
    store.numberFormat = _v('settingNumberFormat', 'en-US');
    settings.numberFormat = store.numberFormat;

    settings.navZoom = parseFloat(document.getElementById('navZoomSlider')?.value || 1.0);
    settings.topZoom = parseFloat(document.getElementById('topZoomSlider')?.value || 1.0);
    settings.leadsZoom = parseFloat(document.getElementById('leadsZoomSlider')?.value || 1.0);
    settings.uiFontScale = parseFloat(document.getElementById('settingUIFontScale')?.value || 1.0);

    localStorage.setItem('m2m_settings', JSON.stringify(settings));
    window.supabaseDB.saveSetting('general', { comisionM2M: settings.comisionM2M, ventanaViaje: settings.ventanaViaje, responsableDefault: settings.responsableDefault, formatoFecha: settings.formatoFecha, numberFormat: settings.numberFormat });
    window.supabaseDB.saveSetting('abonos', { disney: settings.abonoDisney, universal: settings.abonoUniversal, crucero: settings.abonoCrucero, hotel: settings.abonoHotel });
    window.supabaseDB.saveSetting('alertas', { abono: settings.alertaAbono, pagoFinal: settings.alertaPagoFinal, viaje: settings.alertaViaje, whatsApp: settings.alertaWhatsApp, autoTareaWhatsApp: settings.autoTareaWhatsApp });
    window.supabaseDB.saveSetting('vista', { modoCompactoDefault: settings.modoCompactoDefault, ocultarValoresDefault: settings.ocultarValoresDefault, incluirHistoricoDefault: settings.incluirHistoricoDefault, navZoom: settings.navZoom, topZoom: settings.topZoom, leadsZoom: settings.leadsZoom, uiFontScale: settings.uiFontScale });
    window.supabaseDB.saveSetting('hitos', settings.hitos);

    state.modoCompleto = !settings.modoCompactoDefault;
    state.ocultarValores = settings.ocultarValoresDefault;
    state.showHistorico = settings.incluirHistoricoDefault;

    document.getElementById('modoCompletoCheck').checked = state.modoCompleto;
    document.getElementById('includeHistorico').checked = state.showHistorico;

    const btn = document.getElementById('btnOcultarValores');
    if (btn) {
        btn.innerHTML = state.ocultarValores ? '👁️‍🗨️' : '👁️';
    }

    updateComisionLabels();
    window.renderAll();
    window.closeModal('settingsModal');
    window.toast('✓ Configuración guardada', 'success');
}

function resetSettings() {
    if (!confirm('¿Restaurar todos los valores por defecto?')) return;
    store.settings = { ...defaultSettings };
    localStorage.removeItem('m2m_settings');
    openSettings();
    window.toast('↺ Valores restaurados', 'success');
}


// ========== HITOS SETTINGS ==========

function renderHitosSettings() {
    const container = document.getElementById('hitosContainer');
    const { settings } = store;
    const hitos = settings.hitos || defaultSettings.hitos;

    const grupos = {};
    OPERADORES_HITOS.forEach(op => grupos[op.id] = []);
    hitos.forEach(h => {
        if (grupos[h.operador]) grupos[h.operador].push(h);
        else grupos['otro'].push(h);
    });

    let html = '';
    OPERADORES_HITOS.forEach(op => {
        const hitosOp = grupos[op.id];
        if (hitosOp.length === 0) return;

        html += `<div class="hitos-grupo" style="margin-bottom:12px;">
            <div style="font-size:11px;font-weight:600;color:${op.color};margin-bottom:6px;display:flex;align-items:center;gap:6px;">
                ${op.nombre}
                <span style="font-size:10px;font-weight:400;color:var(--text-3);">(${hitosOp.filter(h => h.activo).length} activos)</span>
            </div>`;

        hitosOp.forEach(h => {
            html += `<div class="hito-row" data-id="${h.id}" data-operador="${h.operador}" style="display:flex;align-items:center;gap:6px;padding:6px 8px;background:var(--bg-2);border-radius:6px;margin-bottom:4px;font-size:12px;">
                <label style="display:flex;align-items:center;cursor:pointer;">
                    <input type="checkbox" class="hito-activo" ${h.activo ? 'checked' : ''} style="width:14px;height:14px;">
                </label>
                <select class="hito-icon" style="width:40px;padding:2px;background:var(--bg-1);border:1px solid var(--border);border-radius:4px;font-size:14px;">
                    ${ICONOS_HITOS.map(i => `<option value="${i}" ${h.icon === i ? 'selected' : ''}>${i}</option>`).join('')}
                </select>
                <input type="text" class="hito-nombre" value="${h.nombre}" style="flex:1;padding:4px 6px;background:var(--bg-1);border:1px solid var(--border);border-radius:4px;font-size:11px;color:var(--text-1);">
                <input type="number" class="hito-dias" value="${h.dias}" min="1" max="365" style="width:50px;padding:4px 6px;background:var(--bg-1);border:1px solid var(--border);border-radius:4px;font-size:11px;text-align:center;color:var(--text-1);">
                <span style="font-size:10px;color:var(--text-3);">días</span>
                <select class="hito-operador" style="width:90px;padding:2px 4px;background:var(--bg-1);border:1px solid var(--border);border-radius:4px;font-size:10px;color:var(--text-2);" onchange="moveHitoToOperador('${h.id}', this.value)">
                    ${OPERADORES_HITOS.map(o => `<option value="${o.id}" ${h.operador === o.id ? 'selected' : ''}>${o.nombre.replace(/^[^\s]+\s/, '')}</option>`).join('')}
                </select>
                <button type="button" class="btn-hito-delete" onclick="removeHitoRow('${h.id}')" style="background:none;border:none;color:var(--red);cursor:pointer;font-size:14px;padding:2px;" title="Eliminar">✕</button>
            </div>`;
        });

        html += '</div>';
    });

    if (html === '') {
        html = '<div style="text-align:center;color:var(--text-3);padding:20px;font-size:12px;">No hay hitos configurados. Haz clic en "➕ Agregar" para crear uno.</div>';
    }

    container.innerHTML = html;
}

function moveHitoToOperador(id, newOperador) {
    const { settings } = store;
    if (!settings.hitos) settings.hitos = [...defaultSettings.hitos];
    const hito = settings.hitos.find(h => h.id === id);
    if (hito) {
        hito.operador = newOperador;
        renderHitosSettings();
    }
}

function addHitoRow() {
    const { settings } = store;
    const newId = 'h_' + Date.now();
    if (!settings.hitos) settings.hitos = [...defaultSettings.hitos];

    settings.hitos.push({
        id: newId,
        operador: 'disney',
        nombre: 'Nuevo Hito',
        dias: 7,
        icon: '📋',
        activo: true
    });

    renderHitosSettings();
    const container = document.getElementById('hitosContainer');
    container.scrollTop = container.scrollHeight;
}

function removeHitoRow(id) {
    const { settings } = store;
    if (!settings.hitos) return;
    const idx = settings.hitos.findIndex(h => h.id === id);
    if (idx > -1) {
        settings.hitos.splice(idx, 1);
        renderHitosSettings();
    }
}

function collectHitosFromForm() {
    const rows = document.querySelectorAll('#hitosContainer .hito-row');
    const hitos = [];

    rows.forEach(row => {
        const id = row.dataset.id;
        const operadorSelect = row.querySelector('.hito-operador');

        hitos.push({
            id,
            operador: operadorSelect ? operadorSelect.value : (row.dataset.operador || 'otro'),
            nombre: row.querySelector('.hito-nombre')?.value?.trim() || 'Sin nombre',
            dias: parseInt(row.querySelector('.hito-dias')?.value) || 7,
            icon: row.querySelector('.hito-icon')?.value || '📋',
            activo: row.querySelector('.hito-activo')?.checked ?? false
        });
    });

    return hitos;
}


// ========== PLANTILLAS DE MENSAJES ==========
let plantillasTemp = null;

function openPlantillasModal() {
    const { settings } = store;
    plantillasTemp = JSON.parse(JSON.stringify(settings.plantillas || defaultSettings.plantillas));
    renderPlantillaEditor();
    window.openModal('plantillasModal');
}

function renderPlantillaEditor() {
    const categoria = document.getElementById('plantillaCategoria').value;
    const variaciones = plantillasTemp[categoria] || [];

    let html = '';
    variaciones.forEach((texto, idx) => {
        html += `<div class="plantilla-variacion" data-idx="${idx}" style="margin-bottom:10px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;">
                <span style="font-size:10px;color:var(--text-3);">Variación ${idx + 1}</span>
                <button type="button" onclick="removePlantillaVariacion(${idx})" style="background:none;border:none;color:var(--red);cursor:pointer;font-size:12px;" title="Eliminar">✕</button>
            </div>
            <textarea class="form-input plantilla-texto" rows="4" style="font-size:12px;resize:vertical;"
                      onkeyup="updatePlantillaPreview()" onchange="updatePlantillaTemp(${idx}, this.value)">${texto}</textarea>
        </div>`;
    });

    if (variaciones.length === 0) {
        html = '<div style="text-align:center;color:var(--text-3);padding:20px;font-size:12px;">No hay variaciones. Haz clic en "➕ Agregar variación".</div>';
    }

    document.getElementById('plantillasVariaciones').innerHTML = html;
    updatePlantillaPreview();
}

function addPlantillaVariacion() {
    const categoria = document.getElementById('plantillaCategoria').value;
    if (!plantillasTemp[categoria]) plantillasTemp[categoria] = [];
    plantillasTemp[categoria].push('Hola {nombre}!\n\n[Escribe tu mensaje aquí]\n\nSaludos!');
    renderPlantillaEditor();
    const container = document.getElementById('plantillasVariaciones');
    container.scrollTop = container.scrollHeight;
}

function removePlantillaVariacion(idx) {
    const categoria = document.getElementById('plantillaCategoria').value;
    if (plantillasTemp[categoria] && plantillasTemp[categoria].length > 1) {
        plantillasTemp[categoria].splice(idx, 1);
        renderPlantillaEditor();
    } else {
        window.toast('Debe haber al menos una variación', 'error');
    }
}

function updatePlantillaTemp(idx, value) {
    const categoria = document.getElementById('plantillaCategoria').value;
    if (plantillasTemp[categoria]) {
        plantillasTemp[categoria][idx] = value;
    }
}

function updatePlantillaPreview() {
    const categoria = document.getElementById('plantillaCategoria').value;
    const variaciones = plantillasTemp[categoria] || [];

    if (variaciones.length === 0) {
        document.getElementById('plantillaPreview').textContent = '(Sin variaciones)';
        return;
    }

    let texto = variaciones[0];
    const ejemplos = {
        '{nombre}': 'María',
        '{titular}': 'María González',
        '{destino}': 'Disney World',
        '{fecha_viaje}': '15 de marzo, 2026',
        '{dias_para}': '7',
        '{monto}': '500',
        '{hito}': 'reservar restaurantes'
    };
    Object.keys(ejemplos).forEach(key => {
        texto = texto.replace(new RegExp(key.replace(/[{}]/g, '\\$&'), 'g'), ejemplos[key]);
    });
    document.getElementById('plantillaPreview').textContent = texto;
}

function savePlantillas() {
    const { settings } = store;
    const categoria = document.getElementById('plantillaCategoria').value;
    const textareas = document.querySelectorAll('#plantillasVariaciones .plantilla-texto');
    plantillasTemp[categoria] = Array.from(textareas).map(t => t.value);

    settings.plantillas = plantillasTemp;
    localStorage.setItem('m2m_settings', JSON.stringify(settings));

    window.closeModal('plantillasModal');
    window.toast('✓ Plantillas guardadas', 'success');
}

function resetPlantillas() {
    if (!confirm('¿Restaurar todas las plantillas a los valores por defecto?')) return;
    plantillasTemp = JSON.parse(JSON.stringify(defaultSettings.plantillas));
    renderPlantillaEditor();
    window.toast('↺ Plantillas restauradas', 'success');
}

function generarMensaje(categoria, datos) {
    const { settings } = store;
    const plantillas = settings.plantillas || defaultSettings.plantillas;
    const variaciones = plantillas[categoria] || plantillas['hito_general'];

    if (!variaciones || variaciones.length === 0) return '';

    const idx = Math.floor(Math.random() * variaciones.length);
    let mensaje = variaciones[idx];

    Object.keys(datos).forEach(key => {
        const regex = new RegExp(`{${key}}`, 'g');
        mensaje = mensaje.replace(regex, datos[key] || '');
    });

    return mensaje;
}

function getPlantillaCategoria(eventType, operador) {
    if (eventType.includes('viaje') && !eventType.includes('fin')) return 'viaje_inicio';
    if (eventType.includes('viaje-fin') || eventType.includes('postventa')) return 'viaje_fin';
    if (eventType.includes('pago')) {
        return eventType.includes('abono') ? 'pago_abono' : 'pago_final';
    }
    if (eventType.includes('cumple')) return 'cumpleanos';
    if (eventType.includes('hito')) {
        if (operador === 'disney' || operador === 'disney_cruise') return 'hito_disney';
        if (operador === 'crucero') return 'hito_crucero';
        if (operador === 'universal') return 'hito_universal';
        return 'hito_general';
    }
    return 'hito_general';
}

function generarWhatsAppLink(telefono, mensaje) {
    const tel = telefono.replace(/\D/g, '');
    const texto = encodeURIComponent(mensaje);
    return `https://wa.me/${tel}?text=${texto}`;
}

function generarEmailLink(email, asunto, mensaje) {
    const subject = encodeURIComponent(asunto);
    const body = encodeURIComponent(mensaje);
    return `mailto:${email}?subject=${subject}&body=${body}`;
}

// ========== AUTH HELPERS ==========

function togglePasswordVisibility() {
    const pwd = document.getElementById('loginPassword');
    const btn = document.getElementById('btnTogglePwd');
    const eyeOpen = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>';
    const eyeClosed = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>';
    if (pwd.type === 'password') { pwd.type = 'text'; btn.innerHTML = eyeClosed; btn.title = 'Ocultar contraseña'; }
    else { pwd.type = 'password'; btn.innerHTML = eyeOpen; btn.title = 'Mostrar contraseña'; }
}

function updateUserDisplay() {
    const nameEl = document.getElementById('userName');
    const roleEl = document.getElementById('userRole');
    const avatarEl = document.getElementById('userAvatar');
    const currentUser = window.supabaseDB.currentUser;
    if (currentUser && currentUser.email) {
        const emailToName = {
            'sara.mind2magic@gmail.com': { name: 'Sara', role: 'Directora', initial: 'S' },
            'saramava@gmail.com': { name: 'Sara', role: 'Directora', initial: 'S' },
            'contact.mind2magic@gmail.com': { name: 'Matías', role: 'Operaciones/Financiero', initial: 'M' },
        };
        const member = emailToName[currentUser.email] || { name: currentUser.email.split('@')[0], role: 'Equipo', initial: currentUser.email[0].toUpperCase() };
        if (nameEl) nameEl.textContent = member.name;
        if (roleEl) roleEl.textContent = member.role;
        if (avatarEl) avatarEl.textContent = member.initial;
    }
}

function toggleOcultarValores() {
    const state = store;
    state.ocultarValores = !state.ocultarValores;
    const btn = document.getElementById('btnOcultarValores');
    if (btn) {
        btn.innerHTML = state.ocultarValores ? '👁️‍🗨️' : '👁️';
        btn.title = state.ocultarValores ? 'Mostrar valores monetarios' : 'Ocultar valores monetarios';
    }
    window.renderAll();
    if (store?.currentLeadId) {
        window.openLead(store.currentLeadId);
    }
    window.toast(state.ocultarValores ? '🔒 Valores ocultos' : '👁️ Valores visibles', 'success');
}


// Register on window
Object.assign(window, {
    loadSettings, openSettings, updateDatePreview, saveSettings, resetSettings,
    renderHitosSettings, moveHitoToOperador, addHitoRow, removeHitoRow, collectHitosFromForm,
    openPlantillasModal, renderPlantillaEditor, addPlantillaVariacion, removePlantillaVariacion,
    updatePlantillaTemp, updatePlantillaPreview, savePlantillas, resetPlantillas,
    generarMensaje, getPlantillaCategoria, generarWhatsAppLink, generarEmailLink,
    togglePasswordVisibility, updateUserDisplay, toggleOcultarValores,
});
